module.exports = __webpack_public_path__ + "static/img/ccsb-C57crC8_.2ab5ccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/ccsb-C57crC8_.png
// module id = +ZbK
// module chunks = 16